import type { ReactNode } from 'react';
import React, { Component } from 'react';
import { StyleSheet, Text, View } from 'react-native';

type Props = { children: ReactNode };
type State = { hasError: boolean };

export class RootErrorBoundary extends Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch() {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <View style={styles.wrapper}>
          <Text style={styles.text}>Oops!</Text>
          <Text style={styles.text}>Something went wrong.</Text>
          <Text style={styles.emoticon}>:-/</Text>
          <Text style={styles.text}>Please try to reload the app.</Text>
        </View>
      );
    }

    return this.props.children;
  }
}

const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    marginTop: 26,
    fontSize: 23,
  },
  emoticon: { marginTop: 16, fontSize: 42 },
});
